import Immutable from 'seamless-immutable';
import { createSelector } from 'reselect';

// Types
export const types = {
  //
  // SUBSCRIBE
  //
  SUBSCRIBE_REQUEST: 'SUBSCRIBE_REQUEST',
  SUBSCRIBE_SUCCESS: 'SUBSCRIBE_SUCCESS',
  SUBSCRIBE_ERROR: 'SUBSCRIBE_ERROR',

  //
  // FETCH SUBSCRIBERS
  //
  FETCH_SUBSCRIBERS_REQUEST: 'FETCH_SUBSCRIBERS_REQUEST',
  FETCH_SUBSCRIBERS_SUCCESS: 'FETCH_SUBSCRIBERS_SUCCESS',
  FETCH_SUBSCRIBERS_ERROR: 'FETCH_SSUBSCRIBERS_ERROR',
};

const initialState = Immutable({
  subscribers: [],
  requested: {},
});

// Reducer
export default (state = initialState, action: any) => {
  switch (action.type) {
    //
    // FETCH SUBSCRIBERS
    //
    case types.FETCH_SUBSCRIBERS_REQUEST:
      return state.merge({
        subscribers: Immutable([]),
        requested: { ...action.payload.params },
      });
    case types.FETCH_SUBSCRIBERS_SUCCESS:
      return state.merge({
        subscribers: action.payload.subscriptions,
      });
    default:
      return state;
  }
};

// Actions
export const actions = {
  //
  // SUBSCRIBING
  //
  subscribeRequest: () => ({
    type: types.SUBSCRIBE_REQUEST,
  }),
  subscribeSuccess: ({ boardId, subscribed }: { boardId: string; subscribed: boolean }) => ({
    type: types.SUBSCRIBE_SUCCESS,
    payload: { boardId, subscribed },
  }),
  subscribeError: ({ error }: { error: string }) => ({
    type: types.SUBSCRIBE_ERROR,
    payload: { error },
  }),
  //
  // FETCH SUBSCRIBERS
  //
  fetchSubscribersRequest: (params: any) => ({
    type: types.FETCH_SUBSCRIBERS_REQUEST,
    payload: { params },
  }),
  fetchSubscribersSuccess: ({ subscriptions }: { subscriptions: any[] }) => ({
    type: types.FETCH_SUBSCRIBERS_SUCCESS,
    payload: { subscriptions },
  }),
  fetchSubscribersError: ({ error }: { error: string }) => ({
    type: types.FETCH_SUBSCRIBERS_ERROR,
    payload: { error },
  }),
};

// Selectors
const subscribersSelector = () => (state: any) => state.subscribers;

export const selectSubscribers = () =>
  createSelector(subscribersSelector(), (subscribersState: any) => subscribersState.subscribers);

export const selectRequested = () =>
  createSelector(subscribersSelector(), (subscribersState: any) => subscribersState.requested);
